import React, {useState, useEffect} from 'react';
import axiosInstance from '../axios/axiosInstance';
import {useNavigate, useParams} from 'react-router-dom';
import {
    Tabs,
    Modal,
    Button,
    Select,
    Tag,
    Typography,
    Divider,
    Switch,
    Spin,
    Collapse,
    Checkbox,
    Alert,
    Descriptions, Image,
    Space, Timeline, Radio, Tooltip, List, Drawer, Input, Table, Pagination, Grid
} from 'antd';
import {PageShell, VisitStatusBadge} from '../components/ui';
import {endVisit, fetchVisits, startVisit} from '../services/visitService';
import {PaymentHistoryTable} from '../components/PaymentHistoryTable';
import PatientHistoryPanel from '../components/PatientHistoryPanel';
import AccordionCustomIcon from '../components/AccordionCustomIcon';
import {PiCashRegisterFill, PiEyeClosedBold, PiMedalFill} from "react-icons/pi";
import {ImEye} from "react-icons/im";
import {MdHealthAndSafety, MdOutlineAdsClick, MdPlayLesson} from "react-icons/md";
import {BsFileEarmarkMedicalFill, BsFillStopwatchFill, BsSignStopFill} from "react-icons/bs";
import {ChevronUpDownIcon} from "@heroicons/react/24/outline";
import {getDispensaryDataPatient} from "../services/dispansery";
import {GiReceiveMoney, GiStopwatch} from "react-icons/gi";
import {
    FaArrowsTurnToDots, FaBriefcaseMedical,
    FaCashRegister, FaCreditCard, FaFileInvoice, FaFileSignature,
    FaHandPointLeft, FaHeartCircleCheck,
    FaHospitalUser,
    FaMoneyBillTransfer, FaStethoscope
} from "react-icons/fa6";
import {AiOutlineExclamationCircle} from "react-icons/ai";
import {TbInfoSquareRoundedFilled, TbMessageReport} from "react-icons/tb";
import {BriefcaseIcon, BuildingOfficeIcon, CalendarIcon, PhoneIcon, UserGroupIcon} from "@heroicons/react/24/solid";
import {HiLocationMarker} from "react-icons/hi";
import {FaCalendarAlt, FaUserMd} from "react-icons/fa";
import dayjs from "dayjs";
import { useTranslation } from 'react-i18next';
const { Option } = Select;

const {Panel} = Collapse;

const BRAND = '#1D2C7B';

const visitStatusPillStyles = {
    queue: { bg: '#F59E0B', fg: '#FFFFFF' },
    examined: { bg: '#10B981', fg: '#FFFFFF' },
    new: { bg: '#3B82F6', fg: '#FFFFFF' },
    pending: { bg: '#F97316', fg: '#FFFFFF' },
    closed: { bg: '#64748B', fg: '#FFFFFF' },
    payed: { bg: '#8B5CF6', fg: '#FFFFFF' },
    revisit: { bg: '#EAB308', fg: '#422006' },
    null: { bg: '#CBD5E1', fg: '#475569' },
};

const statusLabelsGlobal = {
    queue: 'Navbatda',
    examined: 'Qabulda',
    new: 'Yangi qabul',
    pending: 'To‘lov kutilmoqda',
    payed: 'To‘langan',
    revisit: 'Navbatda',
    closed: 'Yopilgan',
    null: 'Faol emas',
};

function PatientVisitStatusBadge({ visit }) {
    return <VisitStatusBadge status={visit} />;
}

function getPatientInitials(name) {
    if (!name || typeof name !== 'string') return '?';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
        return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase();
    }
    const word = parts[0] ?? '';
    if (word.length >= 2) return word.slice(0, 2).toUpperCase();
    return (word[0] ?? '?').toUpperCase();
}

function formatInfoValue(value) {
    if (value === undefined || value === null) return '—';
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed || trimmed === 'undefined' || trimmed === 'null') return '—';
        return trimmed;
    }
    if (typeof value === 'object') {
        const inner = value.name ?? value.title ?? value.label;
        return inner != null ? formatInfoValue(inner) : '—';
    }
    return String(value);
}

function PatientInfoCell({ label, value }) {
    const text = formatInfoValue(value);
    return (
        <div className="bg-white px-4 py-3 min-w-0">
            <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-400">{label}</p>
            <p className="text-sm text-slate-800 mt-1 truncate" title={text}>
                {text}
            </p>
        </div>
    );
}

function PatientBioCard() {
    const { t } = useTranslation();
    const token = localStorage.getItem('token');
    const screens = Grid.useBreakpoint();
    const isPhone = screens.md === false;
    const {index} = useParams();
    const [patientData, setPatientData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [mostRecentVisit, setMostRecentVisit] = useState(null);
    const [visits, setVisits] = useState({});
    const [visitId, setVisitId] = useState(null);
    const [dataCache, setDataCache] = useState({});
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedDoctor, setSelectedDoctor] = useState('');
    const [epidemData, setEpidemData] = useState([]);
    const [selectedService, setSelectedService] = useState(null); // Состояние для выбранного сервиса
    const [selectedPartner, setSelectedPartner] = useState(null); // Состояние для выбранного партнера
    const [services, setServices] = useState([]);
    const [patientVisits, setPatientVisits] = useState([]);
    const [partners, setPartners] = useState([]);
    const [doctors, setDoctors] = useState([]);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();
    const [discounts, setDiscounts] = useState([]);
    const [selectedDiscount, setSelectedDiscount] = useState(null);
    const userRole = localStorage.getItem("userRole");
    const [isLoading, setIsLoading] = useState(false);
    const [teethCondition, setTeethCondition] = useState({});
    const [forms, setForms] = useState([]);
    const [doctorNameById, setDoctorNameById] = useState({});
    const [pageData, setPageData] = useState({
        currentPage: 1,
        lastPage: 1,
        nextPage: null,
        prevPage: null
    });

    dayjs.locale('uz');
    const fetchPatientData = async () => {
        try {
            const patientResponse = await axiosInstance.get(`/patients/${index}`);

            const {data} = patientResponse.data;

            const partnerId = data.partner_id;
            const districtId = data.district_id;

            let partnerResponse, districtResponse;

            if (partnerId) {
                partnerResponse = await axiosInstance.get(`/partners/${partnerId}`);
            }

            if (districtId) {
                districtResponse = await axiosInstance.get(`/global/district/${districtId}`);
            }

            const patientData = {
                patient: data,
                partnerName: partnerResponse ? partnerResponse.data.data.name : null,
                provinceName: districtResponse ? districtResponse.data.data.province.name : null,
                districtName: districtResponse ? districtResponse.data.data.name : null,
                remarks: data.remarks,
            };

            setPatientData(patientData);
            setLoading(false);
        } catch (error) {
            console.error("Ошибка при получении информации о пациенте:", error);
        }
    };

    const fetchForms = async (page = 1) => {
        if (!index) return; // Ensure index is available before making API call

        setLoading(true);
        try {
            const response = await axiosInstance.get(`/doctor/form`, {
                params: {
                    patient_id: index,
                    page: page
                }
            });
            setForms(response.data.data);
            setPageData({
                currentPage: response.data.meta.current_page,
                lastPage: response.data.meta.last_page,
                nextPage: response.data.links.next,
                prevPage: response.data.links.prev
            });
        } catch (error) {
            console.error('Error fetching forms:', error);
        } finally {
            setLoading(false);
        }
    };

    const renderTeethValue = (teeth, position) => {
        if (!teeth) return ''; // Возвращаем пустую строку, если teeth не определен
        return teeth[position] || ''; // Если значение отсутствует, показываем пустую строку
    };

    const teethNumbers = [
        ...Array.from({ length: 8 }, (_, index) => 8 - index),  // Для верхней челюсти: 8, 7, 6, ..., 1
        ...Array.from({ length: 8 }, (_, index) => index + 1)   // Для нижней челюсти: 1, 2, 3, ..., 8
    ];



    const handlePageChange = (page) => {
        fetchForms(page);
    };


    useEffect(() => {
        if (index && token) {
            fetchPatientData().then(() => {
                fetchForms(pageData.currentPage);
            });
        }
    }, [index, token, pageData.currentPage]);

    const handleClick = () => {
        navigate(`/patient/admission/${index}`);
    };

    const fetchDoctors = async () => {
        try {
            const response = await axiosInstance.get("/admin/users");
            const doctorUsers = response.data.data.filter(user => user.roles.includes('doctor'));
            const doctorIdToName = doctorUsers.reduce((acc, user) => {
                acc[user.id] = user.name;
                return acc;
            }, {});

            setDoctorNameById(doctorIdToName);
            setDoctors(doctorUsers);
        } catch (error) {
            console.error("Ошибка при получении списка врачей:", error);
        }
    };

    const fetchDiscounts = async () => {
        try {
            const response = await axiosInstance.get("/discount");
            setDiscounts(response.data.data);
        } catch (error) {
            console.error("Ошибка при получении списка скидок:", error);
        }
    };

    const handleDiscountSelect = (value) => {
        setSelectedDiscount(value);
    };

    useEffect(() => {
        fetchDiscounts();
        fetchDoctors();
    }, []);

    const toggleEpidemActiveStatus = (id) => {
        setEpidemData(epidemData.map(item =>
            item.id === id ? {...item, active: !item.active} : item
        ));
    };


    const handleOk = () => {
        if (patient && patient.epidem) {
            const updatedEpidemData = epidemData.map(epidem => ({
                ...epidem,
                active: patient.epidem.some(patEpidem => patEpidem.id === epidem.id)
            }));
            setEpidemData(updatedEpidemData);
        }
        setIsModalOpen(true);
    };

    const handleNotOk = () => {
        setIsModalOpen(false);
    };

    const fetchRecords = async () => {
        try {
            const response = await axiosInstance.get("/epidemiological");
            const epidemData = response.data.data;
            setEpidemData(epidemData);
            if (patientData) {
                const initialSelectedEpidemIds = patientData.epidem.map(item => item.id);
                const updatedEpidemData = epidemData.map(item => ({
                    ...item,
                    active: initialSelectedEpidemIds.includes(item.id)
                }));
                setEpidemData(updatedEpidemData);
            }
        } catch (error) {
            console.error("Ошибка при получении списка эпидемии:", error);
        }
    };


    const handleSwitchChange = (checked) => {
        setIsVisible(checked);
    };

    const handleServiceSelect = (value) => {
        setSelectedService(value);
    };

    const handlePartnerSelect = (value) => {
        setSelectedPartner(value);
    };

    const handleCreateVisit = async () => {
        setIsLoading(true);

        try {
            let url = `/visit?patient_id=${index}&doctor_id=${selectedPartner}&service_id=${selectedService}`;
            if (selectedDiscount) {
                url += `&discount_id=${selectedDiscount}`;
            }
            const response = await axiosInstance.post(url);
            setVisitId(response.data.id);
            setMostRecentVisit(response.data);
            fetchPatientVisits();
            setIsModalVisible(false);
        } catch (error) {
            console.error("Error creating new visit:", error);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await axiosInstance.get("/admin/service?primary=1");
                setServices(response.data.data);
            } catch (error) {
                console.error("Ошибка при получении списка услуг:", error);
            }
        };

        const fetchPartners = async () => {
            try {
                const response = await axiosInstance.get("/partners");
                const partners = response.data.data;
                setPartners(partners);
            } catch (error) {
                console.error("Ошибка при получении списка партнеров:", error);
            }
        };

        fetchServices();
        fetchPartners();
    }, []);


    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const [dispensaryData, setDispensaryData] = useState(null);

    useEffect(() => {
        const fetchDispensaryData = async () => {
            if (mostRecentVisit && mostRecentVisit.id) {
                try {
                    const data = await getDispensaryDataPatient(mostRecentVisit.id);
                    setDispensaryData(data);
                } catch (error) {
                    console.error('Ошибка при получении данных о диспансере:', error);
                }
            }
        };
        fetchDispensaryData();
    }, [mostRecentVisit]);

    const renderDispensaryDates = () => {
        if (dispensaryData && dispensaryData.data) {
            const currentVisitDate = dispensaryData.data[0]?.visit?.date;
            const mouthDays = dispensaryData.data.map(item => item.mouth_days).flat();
            return (
                <ul>
                    {mouthDays.length > 0
                        ? mouthDays.map(date => <li key={date}>{date}</li>)
                        : <li>{t('admissionPrint.noDispensary')}</li>}
                </ul>
            );
        }
        return <li>{t('admissionPrint.noDispensary')}</li>;
    };

    const [isModalOpenRemark, setIsModalOpenRemark] = useState(false); // Изменено имя переменной
    const [currentRemarkHtml, setCurrentRemarkHtml] = useState(''); // Изменено имя переменной

    // Функция для открытия модала и установки выбранного HTML текста
    const handleOpenModal = (htmlContent) => { // Изменено имя функции
        setCurrentRemarkHtml(htmlContent); // Изменено имя переменной
        setIsModalOpenRemark(true); // Изменено имя переменной
    };

    // Функция для закрытия модала
    const handleCloseModal = () => { // Изменено имя функции
        setIsModalOpenRemark(false); // Изменено имя переменной
        setCurrentRemarkHtml(''); // Изменено имя переменной
    };


    const statusNames = {
        new: 'Янги',
        queue: 'Навбатда',
        pending: 'Ожидание',
        examined: 'Қабулда',
        completed: 'Завершён',
        canceled: 'Отменён',
    };
    const files = mostRecentVisit?.files ?? [];


    const vistTable = [
        {
            key: '1',
            label: t('admissionPrint.conclusion'),
            children: (
                <List
                    dataSource={patientData?.remarks}
                    renderItem={(remark) => (
                        <List.Item
                            className="cursor-pointer hover:bg-gray-100 transition-colors"
                            onClick={() => handleOpenModal(remark.text)}
                        >
                            <div className="flex items-center px-4 py-2 rounded-lg border bg-gray-50">
                                <BsFileEarmarkMedicalFill size={18} color="#1D2C7B" className="mr-2" />
                                <span className="text-sm font-medium text-gray-700">{t('patientCard.visitNoN', { id: remark.visit_id })}</span>
                            </div>
                        </List.Item>
                    )}
                />
            ),
        },

        {
            key: '3',
            label: t('patientCard.revisitDate'),
            children: <>{mostRecentVisit ? mostRecentVisit.date_at : t('patientCard.noInfo')}</>,
        },
        {
            key: '4',
            label: t('patientCard.onDispensary'),
            children: <>{renderDispensaryDates()}</>,
        },
        {
            key: '5',
            label: t('admissionPrint.files'),
            children: (
                <div>
                    <Typography variant="small" color="blue-gray" className="font-normal">
                        <Image.PreviewGroup
                            preview={{
                                onChange: (current, prev) => console.log(`current index: ${current}, prev index: ${prev}`),
                            }}
                        >
                            {Array.isArray(files) && files.length > 0 ? (
                                files.map((file) => (
                                    <Image key={file.id} width={50} src={file.url} alt={file.name} className="mr-2 mb-2" />
                                ))
                            ) : (
                                <p>{t('patientCard.fileNotUploaded')}</p>
                            )}
                        </Image.PreviewGroup>
                    </Typography>
                </div>
            ),
        },
        {
            key: '6',
            label: t('common.view'),
            children: (
                <Button
                    onClick={handleClick}
                    className="flex items-center"
                    icon={<MdOutlineAdsClick className="text-lg" />}
                    type="default"
                >
                    {t('patientCard.viewAll')}
                </Button>
            ),
        },
    ];

    const sendEpidemData = async () => {
        const activeEpidems = epidemData.filter(item => item.active).map(item => item.id);
        const data = { epidem: activeEpidems };

        try {
            const response = await axiosInstance.post(`/patient/epidem/${index}`, data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            console.log("Epidem data sent successfully:", response.data);
            setIsModalOpen(false);
            await fetchPatientData();
            await fetchRecords();
        } catch (error) {
            console.error("Error sending epidem data:", error);
        }
    };


    const fetchPatientVisits = async () => {
        try {
            let visitData = [];
            const fetchAllPages = async (patientId) => {
                let allData = [];
                let page = 1;
                let lastPage = 1;

                while (page <= lastPage) {
                    try {
                        const response = await fetchVisits(patientId, page);
                        const pageData = response.data.data;
                        const meta = response.data.meta;

                        allData = [...allData, ...pageData];
                        lastPage = meta.last_page;
                        page += 1;
                    } catch (error) {
                        console.error(`Ошибка при получении данных со страницы ${page}:`, error);
                        break;
                    }
                }

                return allData;
            };

            visitData = await fetchAllPages(index);

            const recentVisit = visitData.find(visit =>
                visit.parent_id === null &&
                (visit.bill === "payed" || visit.bill === "pending") && (visit.status === "new" || visit.status === "examined" || visit.status === "queue")
            );

            setVisitId(recentVisit ? recentVisit.id : null);
            setVisits(prevVisits => ({
                ...prevVisits,
                [index]: visitData,
            }));

            setPatientVisits(visitData);
            setMostRecentVisit(recentVisit);
        } catch (error) {
            console.error('Error fetching patient visits:', error);
        }
    };

    useEffect(() => {
        fetchRecords();
    }, []);

    useEffect(() => {
        fetchPatientVisits();
    }, [index]);


    const handleStartVisit = async () => {
        setIsButtonLoading(true);
        try {
            await startVisit(visitId);
            setMostRecentVisit(prevVisit => ({...prevVisit, status: "examined"}));

        } catch (error) {
            console.error('Error starting visit:', error);

        } finally {
            setIsButtonLoading(false);
        }
    };

    const handleEndVisit = async () => {
        setIsButtonLoading(true);
        try {
            await endVisit(visitId);
            setMostRecentVisit(prevVisit => ({...prevVisit, status: "", total_payed: 0}));

        } catch (error) {
            console.error('Error ending visit:', error);

        } finally {
            setIsButtonLoading(false);
        }
    };


    const shouldRenderAccordionIcon = mostRecentVisit && mostRecentVisit.status === "examined";
    const isBillPending = mostRecentVisit &&
        mostRecentVisit.bill === "payed1";

    const statusColors = {
        queue: '#EF9300',  // Muted yellow
        examined: '#1D2C7B',  // Flat green
        new: '#3C72F9',  // Flat sky blue
        pending: '#FFA866',  // Soft coral orange
        closed: '#ff3a3a',  // Flat red
        payed: '#9A77FF',  // Soft violet
        revisit: '#ffcf22',  // Muted yellow
        null: '#bdbdbd',  // Soft grey
    };



    const statusLabels = {
        queue: 'Навбатда...',
        examined: 'Қабулда...',
        new: 'Янги кабул',
        pending: 'Тўлов кутилмоқда',
        payed: 'Тўланган',
        revisit: 'Навбатда...',
        closed: 'Йопилган',
        null: 'Фаол емас',
    };

    const transactionTypes = {
        cash: "Нақд",
        card: "Карта",
    };





    const items = [

        {
            key: '1',
            label: t('patientCard.tabNewVisit'),
            children: <div>


                {patientData && shouldRenderAccordionIcon && mostRecentVisit ? (
                    <>


                        <AccordionCustomIcon
                            status={mostRecentVisit.status}
                            discount={mostRecentVisit.discount}
                            visits={visits[index]}
                            patientId={index}
                            visitId={visitId}
                            mkb10={patientData.patient.mkb10}
                            remarks={patientData?.remarks}
                        />
                    </>
                ) : (
                    <>
                        {mostRecentVisit && mostRecentVisit.total_payed > 0 ? (
                            <Alert
                                className="border-none"
                                message={t('patientCard.readyTitle')}
                                description={t('patientCard.readyDesc')}
                                type="success"
                                showIcon
                                icon={<FaHeartCircleCheck size={30}/>}
                            />
                        ) : mostRecentVisit && mostRecentVisit.status === "new" ? (
                            <Alert
                                className="border-none"
                                message={t('patientCard.addedTitle')}
                                description={t('patientCard.addedDesc')}
                                type="warning"
                                showIcon
                                icon={<FaMoneyBillTransfer size={30}/>}
                            />
                        ) : (
                            <Alert
                                className="border-none"
                                message={t('patientCard.notAddedTitle')}
                                description={t('patientCard.notAddedDesc')}
                                type="info"
                                showIcon
                                icon={<TbInfoSquareRoundedFilled className="text-blue-500" size={30}/>}
                            />
                        )}
                    </>
                )}


            </div>,
        },

        {
            key: '2',
            label: t('payments.title'),
            children: <PaymentHistoryTable patientId={index}/>,
        },

        {
            key: 'history',
            label: t('patientCard.tabHistory'),
            children: <PatientHistoryPanel patientId={index} />,
        },

        {
            key: '3',
            label: t('patientCard.tabViewVisits'),
            children:
                <>
                    <Descriptions column={1} title={t('patientCard.visitsTitle')} bordered items={vistTable}/>

                    <Collapse className="mt-5" accordion>
                        {patientVisits.length > 0 ? (
                            patientVisits.map((visit) => (
                                <Panel header={t('patientCard.visitAt', { date: visit.date_at })} key={visit.id}>
                                    <Descriptions bordered column={{xs: 1, sm: 1, md: 2, lg: 3}} size="small">
                                        <Descriptions.Item label={
                                            <div className="flex flex-col items-center text-center">
                                                <div className="p-1 rounded bg-white border">
                                                    <FaHospitalUser size="20" style={{color: '#1D2C7B'}}/>
                                                </div>
                                                {t('common.patient')}
                                            </div>
                                        }>
                                            {visit.patient_id.name}
                                        </Descriptions.Item>
                                        <Descriptions.Item label={
                                            <div className="flex flex-col items-center text-center">
                                                <div className="p-1 rounded bg-white border">
                                                    <FaStethoscope size="20" style={{color: '#1D2C7B'}}/>
                                                </div>
                                                {t('common.doctor')}
                                            </div>
                                        }>
                                            {visit.doctor.name}
                                        </Descriptions.Item>
                                        <Descriptions.Item label={
                                            <div className="flex flex-col items-center text-center">
                                                <div className="p-1 rounded bg-white border">
                                                    <FaCalendarAlt size="20" style={{color: '#1D2C7B'}}/>
                                                </div>
                                                {t('patientCard.visitDate')}
                                            </div>
                                        }>
                                            {visit.date_at}
                                        </Descriptions.Item>
                                        <Descriptions.Item label={
                                            <div className="flex flex-col items-center text-center">
                                                <div className="p-1 rounded bg-white border">
                                                    <FaFileInvoice size="20" style={{color: '#1D2C7B'}}/>
                                                </div>
                                                {t('common.status')}
                                            </div>
                                        }>

                                            <Tag
                                                bordered={false}
                                                className="px-3 py-1 border-opacity-10 font-medium flex max-w-max items-center"
                                                color={visit ? statusColors[visit.status] : 'default'}
                                            >
                                                {visit ? t(`status.${visit.status}`, { defaultValue: visit.status }) : t('status.inactive')}
                                            </Tag>
                                        </Descriptions.Item>
                                        <Descriptions.Item label={
                                            <div className="flex flex-col items-center text-center">
                                                <div className="p-1 rounded bg-white border">
                                                    <FaFileInvoice size="20" style={{color: '#1D2C7B'}}/>
                                                </div>
                                                {t('common.amount')}
                                            </div>
                                        }>
                                            {new Intl.NumberFormat('ru-UZ').format(visit.total_amount)} {t('common.currency')}
                                        </Descriptions.Item>

                                        <Descriptions.Item label={
                                            <div className="flex flex-col items-center text-center">
                                                <div className="p-1 rounded bg-white border">
                                                    <FaCreditCard className="mx-auto" size="20"
                                                                  style={{color: '#1D2C7B'}}/>
                                                </div>
                                                {t('patientCard.paymentType')}
                                            </div>
                                        }>
                                            {visit.transaction.map((transaction, index) => (
                                                <div key={index}>
                                                    <p>{t(`payments.${transaction.type}`, { defaultValue: transaction.type })} - {new Intl.NumberFormat('ru-UZ').format(transaction.amount)} {t('common.currency')}</p>
                                                </div>
                                            ))}
                                        </Descriptions.Item>

                                        <Descriptions.Item
                                            label={
                                                <div className="flex flex-col items-center text-center">
                                                    <div className="p-1 rounded bg-white border">
                                                        <FaStethoscope className="mx-auto" size="20"
                                                                       style={{color: '#1D2C7B'}}/>
                                                    </div>
                                                    {t('common.service')}
                                                </div>
                                            }
                                        >
                                            <List
                                                bordered
                                                dataSource={visit.orders}
                                                renderItem={(order, index) => (
                                                    <List.Item className="even:bg-gray-50" key={index}>
                                                        <div className="flex justify-between  items-center"
                                                             style={{width: '100%'}}>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                fontWeight: '500',
                                                                color: '#495057'
                                                            }}>{order.service.name}</span>
                                                            <span style={{
                                                                fontSize: '13px',
                                                                fontWeight: '500',
                                                                color: '#495057'
                                                            }}>
                                                        {new Intl.NumberFormat('ru-UZ').format(order.amount)} {t('common.currency')}
                                                            </span>

                                                        </div>
                                                    </List.Item>
                                                )}
                                            />
                                        </Descriptions.Item>

                                    </Descriptions>
                                </Panel>
                            ))
                        ) : (
                            <p>{t('patientCard.loadingData')}</p>
                        )}
                    </Collapse>

                </>
            ,
        },

        {
            key: '4',
            label: t('patientCard.title'),
            children: <>
                <Collapse accordion className="flex flex-col">
                    {forms.map((form) => (
                        <Panel header={
                            <div className="flex justify-between items-center text-base font-semibold text-gray-800 hover:text-[#1D2C7B] transition-colors duration-300">
                                <span>{t('patientCard.visitNoN', { id: form.visit_id })}</span>
                                <span className="text-xs text-gray-500">{t('patientCard.dateAt', { date: dayjs(form.created_at).format('DD MMM YYYY, HH:mm') })}</span>
                            </div>
                        } key={form.id} className="border-b">
                            <Descriptions bordered column={1}>
                                <Descriptions.Item label={t('patientCard.complaint')}>{form.complaint || t('common.notEntered')}</Descriptions.Item>
                                <Descriptions.Item label={t('patientCard.illness')}>{form.illness || t('common.notEntered')}</Descriptions.Item>
                                <Descriptions.Item label={t('patientCard.diagnosis')}>{form.diagnoz || t('common.notEntered')}</Descriptions.Item>
                                <Descriptions.Item label={t('patientCard.illHistory')}>{form.ill_history || t('common.notEntered')}</Descriptions.Item>
                                {form.anamnez1 && <Descriptions.Item label={t('patientCard.anamnez', { n: 1 })}>{form.anamnez1}</Descriptions.Item>}
                                {form.anamnez2 && <Descriptions.Item label={t('patientCard.anamnez', { n: 2 })}>{form.anamnez2}</Descriptions.Item>}
                                {form.anamnez3 && <Descriptions.Item label={t('patientCard.anamnez', { n: 3 })}>{form.anamnez3}</Descriptions.Item>}
                                {form.anamnez4 && <Descriptions.Item label={t('patientCard.anamnez', { n: 4 })}>{form.anamnez4}</Descriptions.Item>}
                                {form.anamnez5 && <Descriptions.Item label={t('patientCard.anamnez', { n: 5 })}>{form.anamnez5}</Descriptions.Item>}
                                {form.anamnez6 && <Descriptions.Item label={t('patientCard.anamnez', { n: 6 })}>{form.anamnez6}</Descriptions.Item>}
                                {form.anamnez7 && <Descriptions.Item label={t('patientCard.anamnez', { n: 7 })}>{form.anamnez7}</Descriptions.Item>}
                                <Descriptions.Item label={t('patientCard.treatment')}>{form.treatment || t('patientCard.notAvailable')}</Descriptions.Item>
                            </Descriptions>

                            <div className="flex flex-row mt-4 justify-start space-x-4">
                                {/* Левая текстовая часть */}
                                <div>
                                    <p className="font-bold mb-2">{t('patientCard.oralView')}</p>
                                    <p>{t('patientCard.teethState')}</p>
                                    <ul className="list-disc list-inside">
                                        <li className="mt-1.5">{t('patientCard.condExtracted')} - <span className="inline-flex gap-3 items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">О</span></li>
                                        <li className="mt-1.5">{t('patientCard.condRoot')} - <span className="inline-flex gap-3 items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">R</span></li>
                                        <li className="mt-1.5">{t('patientCard.condCaries')} - <span className="inline-flex gap-3 items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">C</span></li>
                                        <li className="mt-1.5">{t('patientCard.condPulpitis')} - <span className="inline-flex gap-3 items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">P</span>, {t('patientCard.condPeriodontitis')} - <span className="inline-flex gap-3 items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">PT</span></li>
                                        <li className="mt-1.5">{t('patientCard.condParadontosis')} - <span className="inline-flex gap-3 items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">A</span></li>
                                        <li className="mt-1.5">{t('patientCard.condMobility')} - <span className="inline-flex gap-3 items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10 font-serif">I-II-III</span></li>
                                        <li className="mt-1.5">{t('patientCard.condFilling')} - <span className="inline-flex gap-3 items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">K</span>, {t('patientCard.condArtificial')} - <span className="inline-flex gap-3 items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">И</span></li>
                                    </ul>
                                </div>

                                {/* Правая часть с сеткой для отображения значений */}
                                <div className="flex flex-col items-center space-y-4 w-2/3">
                                    {/* Top rows */}
                                    <div className="space-y-1">
                                        {Array.from({ length: 2 }).map((_, rowIndex) => {
                                            const rowLabel = String.fromCharCode(97 + rowIndex); // 'a', 'b', etc.
                                            return (
                                                <div key={`top-row-${rowIndex}`} className="flex justify-center space-x-1">
                                                    {teethNumbers.map((_, colIndex) => {
                                                        const colLabel = colIndex + 1; // Column numbers 1-16
                                                        const position = `${rowLabel}${colLabel}`; // For example, a1, b3, etc.
                                                        return (
                                                            <Button key={`top-${rowIndex}-${colIndex}`}
                                                                    className="w-10 h-10 text-center flex items-center justify-center border border-gray-300">
                                                                {renderTeethValue(form.teeth, position)} {/* Display the value fetched from API */}
                                                            </Button>
                                                        );
                                                    })}
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {/* Number rows */}
                                    <div className="flex justify-center space-x-1 mt-4">
                                        {teethNumbers.map((num, index) => (
                                            <div key={`number-${index}`} className="w-10 h-10 bg-gray-100 flex items-center justify-center border border-gray-300">
                                                {num}
                                            </div>
                                        ))}
                                    </div>

                                    {/* Bottom rows */}
                                    <div className="space-y-1 mt-4">
                                        {Array.from({ length: 3 }).map((_, rowIndex) => {
                                            const rowLabel = String.fromCharCode(97 + rowIndex + 2); // Starts from 'c' for bottom rows
                                            return (
                                                <div key={`bottom-row-${rowIndex}`} className="flex justify-center space-x-1">
                                                    {teethNumbers.map((_, colIndex) => {
                                                        const colLabel = colIndex + 1; // Column numbers 1-16
                                                        const position = `${rowLabel}${colLabel}`; // For example, c1, d10, etc.
                                                        return (
                                                            <Button key={`bottom-${rowIndex}-${colIndex}`}
                                                                    className="w-10 h-10 text-center flex items-center justify-center border border-gray-300">
                                                                {renderTeethValue(form.teeth, position)} {/* Display the value fetched from API */}
                                                            </Button>
                                                        );
                                                    })}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    ))}
                </Collapse>



                {/* Pagination */}
                <Space style={{ marginTop: '16px' }}>
                    <Pagination
                        current={pageData.currentPage}
                        total={pageData.total}
                        pageSize={15}
                        onChange={handlePageChange}
                        showSizeChanger={false}
                        showTotal={(total) => t('patientCard.totalForms', { total })}
                        disabled={loading}
                    />
                </Space>
            </>,
        },

    ];

    if (loading) {
        return (
            <div className="min-h-[50vh] flex items-center justify-center bg-[#f4f6f9]">
                <Spin size="large" />
            </div>
        );
    }

    const {patient, partnerName, provinceName, districtName} = patientData;
    const isButtonDisabled = mostRecentVisit ? ["examined", "new", "queue", "closed"].includes(mostRecentVisit.status) : false;


    const formatPatientPhone = (phone) => {
        if (!phone) return '—';
        const p = String(phone).replace(/\D/g, '');
        if (p.length === 12) {
            return `+998 (${p.slice(3, 5)}) ${p.slice(5, 8)}-${p.slice(8, 10)}-${p.slice(10, 12)}`;
        }
        return phone.startsWith('+') ? phone : `+${phone}`;
    };

    return (
        <>
        <PageShell>
                    <div className="flex items-center gap-2 text-sm text-slate-500">
                        <Switch size="small" checked={isVisible} onChange={handleSwitchChange} />
                        <span>{isVisible ? t('patientCard.hideProfile') : t('patientCard.showProfile')}</span>
                    </div>

                {isVisible && (
                    <div className="rounded-xl border border-slate-200/90 bg-white overflow-hidden shadow-sm">
                        <div className="flex flex-col lg:flex-row lg:items-stretch">
                            <div className="flex flex-1 gap-3 sm:gap-4 p-4 sm:p-5 md:p-6 min-w-0">
                                <div
                                    className="shrink-0 w-14 h-14 sm:w-[4.5rem] sm:h-[4.5rem] rounded-lg flex items-center justify-center text-sm sm:text-base font-bold text-white tracking-wide shadow-sm"
                                    style={{ backgroundColor: BRAND }}
                                    aria-label={patient.name}
                                >
                                    {getPatientInitials(patient.name)}
                                </div>
                                <div className="min-w-0 flex-1">
                                    <p className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-1">{t('patientCard.title')}</p>
                                    <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-[#1D2C7B] truncate">{patient.name}</h1>
                                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-2 text-sm text-slate-500">
                                        <span>{t('common.code')}: <strong className="text-slate-700 font-medium">{patient.code}</strong></span>
                                        <span className="hidden sm:inline text-slate-300">|</span>
                                        <span>{t('patientCard.visitNo')}: <strong className="text-slate-700 font-medium">{visitId ?? t('common.dash')}</strong></span>
                                    </div>
                                    <div className="mt-3">
                                        <PatientVisitStatusBadge visit={mostRecentVisit} />
                                    </div>
                                </div>
                            </div>

                            <div className="lg:w-[240px] shrink-0 p-5 md:p-6 border-t lg:border-t-0 lg:border-l border-slate-100 bg-slate-50/60 flex flex-col justify-center gap-2">
                                    {mostRecentVisit && (mostRecentVisit.status === "new" || mostRecentVisit.status === "queue") ? (
                                            userRole !== "reception" && (
                                                <Button
                                                    block
                                                    type="primary"
                                                    size="large"
                                                    className="!h-10 !rounded-lg !font-semibold"
                                                    onClick={handleStartVisit}
                                                    loading={isButtonLoading || (mostRecentVisit && mostRecentVisit.bill === "pending")}
                                                >
                                                    {isButtonLoading ? t('patientCard.starting') : t('patientCard.startVisit')}
                                                </Button>
                                            )
                                        ) : mostRecentVisit && mostRecentVisit.status === "examined" ? (
                                            userRole !== "reception" && (
                                                <Button
                                                    block
                                                    size="large"
                                                    className="!h-10 !rounded-lg !font-semibold !bg-amber-500 !border-amber-500 hover:!bg-amber-600"
                                                    onClick={handleEndVisit}
                                                    disabled={isButtonLoading}
                                                    loading={isButtonLoading}
                                                >
                                                    {isButtonLoading ? t('patientCard.ending') : t('patientCard.endVisit')}
                                                </Button>
                                            )
                                        ) : (
                                            <Button
                                                block
                                                type="primary"
                                                size="large"
                                                className="!h-10 !rounded-lg !font-semibold"
                                                loading={isButtonDisabled}
                                                onClick={showModal}
                                            >
                                                {t('patientCard.addToVisit')}
                                            </Button>
                                        )}
                            </div>
                        </div>

                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-slate-100 border-t border-slate-100">
                            <PatientInfoCell label={t('patientCard.birthDate')} value={patient.birth_at} />
                            <PatientInfoCell label={t('patientCard.phone')} value={formatPatientPhone(patient.phone)} />
                            <PatientInfoCell label={t('patientCard.province')} value={provinceName} />
                            <PatientInfoCell label={t('patientCard.district')} value={districtName} />
                            <PatientInfoCell label={t('patientCard.partner')} value={partnerName} />
                            <PatientInfoCell label={t('patientCard.address')} value={patient.home_address} />
                            <PatientInfoCell
                                label={t('patientCard.profession')}
                                value={patient.profession ?? patient.job ?? patient.occupation}
                            />
                            <PatientInfoCell
                                label={t('patientCard.gender')}
                                value={
                                    patient.gender === 'male' || patient.gender === 'men'
                                        ? t('patientCard.male')
                                        : patient.gender === 'female' || patient.gender === 'women'
                                          ? t('patientCard.female')
                                          : patient.gender
                                }
                            />
                        </div>

                        <div className="px-4 md:px-6 pb-4 pt-3 border-t border-slate-100">
                            <Collapse accordion className="patient-epidem-collapse !bg-transparent !border-0">
                                <Panel header={t('nav.epidem')} key="1">
                                    <Button type="primary" className="mb-4" onClick={handleOk}>
                                        {t('common.add')}
                                    </Button>
                                    <Modal
                                        title={t('patientCard.addEpidem')}
                                        open={isModalOpen}
                                        onOk={sendEpidemData}
                                        onCancel={handleNotOk}
                                        okText={t('common.add')}
                                        cancelText={t('common.cancel')}
                                        width="100%"
                                        style={{maxWidth: 560}}
                                    >
                                        <table className="mt-2 w-full table-auto text-left border border-slate-100 rounded-lg overflow-hidden">
                                            <thead className="bg-slate-50">
                                            <tr>
                                                <th className="p-3 text-xs font-semibold text-slate-500">{t('epidem.name')}</th>
                                                <th className="p-3 text-xs font-semibold text-slate-500">{t('patientCard.colActive')}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {epidemData.map((item) => (
                                                <tr key={item.id} className="border-t border-slate-100">
                                                    <td className="px-3 py-2 text-sm">{item.name}</td>
                                                    <td className="px-3 py-2">
                                                        <Checkbox checked={item.active} onChange={() => toggleEpidemActiveStatus(item.id)} />
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </Modal>
                                    <table className="min-w-full divide-y divide-slate-100 border border-slate-100 rounded-lg overflow-hidden">
                                        <thead className="bg-slate-50">
                                        <tr>
                                            <th className="px-4 py-2 text-left text-xs font-semibold text-slate-500">{t('patientCard.colTitle')}</th>
                                            <th className="px-4 py-2 text-left text-xs font-semibold text-slate-500">{t('patientCard.colDesc')}</th>
                                        </tr>
                                        </thead>
                                        <tbody className="divide-y divide-slate-100">
                                        {(patient.epidem ?? []).map(epidem => (
                                            <tr key={epidem.id}>
                                                <td className="px-4 py-2 text-sm text-slate-800">{epidem.name}</td>
                                                <td className="px-4 py-2 text-sm text-slate-600">{epidem.description || '—'}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </Panel>
                            </Collapse>
                        </div>
                    </div>
                )}

                    <Drawer
                        centered
                        title={t('patientCard.createVisit')}
                        width={isPhone ? '100%' : 420}
                        open={isModalVisible}
                        onClose={handleCancel}
                        footer={[
                            <Button key="back" onClick={handleCancel}>
                                {t('common.cancel')}
                            </Button>,
                            <Button loading={isLoading} key="submit" type="primary" onClick={handleCreateVisit}>
                                {t('patientCard.createVisitAction')}
                            </Button>,
                        ]}
                    >
                        <div className="flex flex-col gap-4">
                            <div>
                                <label htmlFor="service" className="block text-sm font-medium text-slate-700 mb-1">{t('common.service')}</label>
                                <Select
                                    size="large"
                                    className="w-full"
                                    id="service"
                                    value={selectedService}
                                    onChange={handleServiceSelect}
                                    placeholder={t('patientCard.pickService')}
                                >
                                    {services.map(service => (
                                        <Select.Option key={service.id} value={service.id}>
                                            {service.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                            <div>
                                <label htmlFor="partner" className="block text-sm font-medium text-slate-700 mb-1">{t('common.doctor')}</label>
                                <Select
                                    size="large"
                                    className="w-full"
                                    id="partner"
                                    value={selectedPartner}
                                    onChange={handlePartnerSelect}
                                    placeholder={t('calendar.pickDoctor')}
                                >
                                    {doctors.map(partner => (
                                        <Select.Option key={partner.id} value={partner.id}>
                                            {partner.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                            <div>
                                <label htmlFor="discount" className="block text-sm font-medium text-slate-700 mb-1">{t('patientCard.discount')}</label>
                                <Select
                                    size="large"
                                    className="w-full"
                                    id="discount"
                                    value={selectedDiscount}
                                    onChange={handleDiscountSelect}
                                    placeholder={t('patientCard.pickDiscount')}
                                >
                                    {discounts.map(discount => {
                                        const isExpired = dayjs(discount.end_at).isBefore(dayjs());
                                        return (
                                            <Select.Option key={discount.id} value={discount.id} disabled={isExpired}>
                                                {`${discount.title} - ${discount.percent}%`}
                                            </Select.Option>
                                        );
                                    })}
                                </Select>
                            </div>
                        </div>
                    </Drawer>

                    <div className="rounded-xl border border-slate-200/90 bg-white shadow-sm overflow-hidden patient-bio-tabs-wrap">
                        <Tabs
                            className="patient-bio-tabs px-1 sm:px-2 md:px-4"
                            animated
                            defaultActiveKey="1"
                            type="line"
                            size={isPhone ? 'small' : 'middle'}
                            items={items}
                        />
                    </div>
            </PageShell>

            <Modal
                title={t('patientCard.noteText')}
                visible={isModalOpenRemark} // Изменено имя переменной
                onCancel={handleCloseModal} // Изменено имя функции
                footer={null} // Если не хотите добавлять кнопки, можно передать null
            >
                <div dangerouslySetInnerHTML={{__html: currentRemarkHtml}}/>
                {/* Отображаем HTML-код */}
            </Modal>
        </>
    );
}

export default PatientBioCard;